import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Add fade-in animation
    this.element.style.opacity = "0"
    requestAnimationFrame(() => {
      this.element.style.opacity = "1"
    })

    // Auto-remove after 5 seconds
    setTimeout(() => {
      this.element.style.opacity = "0"
      this.element.addEventListener("transitionend", () => {
        this.element.remove()
      }, { once: true })
    }, 5000)
  }

  remove() {
    this.element.remove()
  }
}
